export default function DashboardIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 1H2.5C1.65 1 1 1.7 1 2.5V13C1 13.85 1.65 14.5 2.5 14.5H9.5C10.35 14.5 11 13.85 11 13V2.5C11 1.7 10.35 1 9.5 1ZM9.5 16.5H2.5C1.65 16.5 1 17.15 1 18V21.5C1 22.35 1.65 23 2.5 23H9.5C10.35 23 11 22.35 11 21.5V18C11 17.15 10.35 16.5 9.5 16.5ZM22 9.5H14.5C13.65 9.5 13 10.15 13 11V21.45C13 22.3 13.65 22.95 14.5 22.95H22C22.85 22.95 23.5 22.3 23.5 21.45V11C23.5 10.2 22.85 9.5 22 9.5ZM22 1H14.5C13.65 1 13 1.65 13 2.5V6.05C13 6.9 13.65 7.55 14.5 7.55H22C22.85 7.55 23.5 6.9 23.5 6.05V2.5C23.5 1.7 22.85 1 22 1Z"
        fill={color}
      />
    </svg>
  );
}
